import React, { useState } from 'react'
import Select, { components } from 'react-select'

import './combobox-pillboxes.scss'

const ComboboxPillboxes = ({ coupon }) => {
  const [state, setState] = useState({
    options: [
      { value: 'category1', label: 'Category 1' },
      { value: 'category2', label: 'Category 2' },
      { value: 'category3', label: 'Category 3' }
    ]
  })

  const Placeholder = props => {
    return <components.Placeholder {...props} />;
  }
  return (
    <div>
      <Select
        isMulti
        className="basic-multi-select"
        classNamePrefix="select"
        components={{ Placeholder }}
        placeholder={'Выберите…'}
        options={coupon || state.options} />
    </div>
  )
}

export default ComboboxPillboxes
